module.exports = __webpack_public_path__ + "img/photo-12.fb86993e.jpg";